module.exports = __webpack_public_path__ + "img/18.f85f2364.png";